import { Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ViewInformationDialogComponent } from './parts/view-information-dialog/view-information-dialog.component';

@Component({
  selector: 'admin-view-information',
  templateUrl: './view-information.component.html',
  styleUrls: ['./view-information.component.scss'],
  standalone: false
})
export class ViewInformationComponent {
  private matDialog = inject(MatDialog);

  readonly translationPrefix = input<string>(undefined);

  public openInformationDialog(): void {
    this.matDialog.open(ViewInformationDialogComponent, {
      width: '50vw',
      maxWidth: '2000px',
      data: { translationPrefix: this.translationPrefix() }
    });
  }
}
